import { trackEvent } from './track';

/* ---------- Navigation ---------- */
export const trackNavClick = (params) => trackEvent('nav_click', params);

/* ---------- CTA ---------- */
export const trackCtaClick = (params) => trackEvent('cta_click', params);

/* ---------- Search ---------- */
export const trackSearchPerformed = (params) => trackEvent('search_performed', params);

export const trackSearchNoResults = (params) => trackEvent('search_no_results', params);

/* ---------- Listing Courses ---------- */
export const trackViewItemList = (params) => trackEvent('view_item_list', params);

export const trackSelectContent = (params) => trackEvent('select_content', params);

/* ---------- Filters & Sort ---------- */
export const trackFilterApplied = (params) => trackEvent('filter_applied', params);

export const trackFilterCleared = (params) => trackEvent('filter_cleared', params);

export const trackSortChanged = (params) => trackEvent('sort_changed', params);

/* ---------- Course Detail ---------- */
export const trackViewItem = (params) => trackEvent('view_item', params);

export const trackSectionToggle = (params) => trackEvent('section_toggle', params);

/* ---------- Cart & Checkout ---------- */
export const trackAddToCart = (params) => trackEvent('add_to_cart', params);

export const trackViewCart = (params) => trackEvent('view_cart', params);

export const trackRemoveFromCart = (params) => trackEvent('remove_from_cart', params);

export const trackCheckoutStepView = (params) => trackEvent('checkout_step_view', params);

export const trackAddPaymentInfo = (params) => trackEvent('add_payment_info', params);

export const trackBeginCheckout = (params) => trackEvent('begin_checkout', params);

export const trackPurchase = (params) => trackEvent('purchase', params);

export const trackPurchaseFailed = (params) => trackEvent('purchase_failed', params);
